module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-BOOSTER-GREEN-4.0cec04d8.jpg";